import React from 'react';
import { Box, HStack } from '@chakra-ui/react';

const DOT_DELAY = ['0s', '0.15s', '0.3s'];

const TypingIndicator = ({ colors }) => {
    return (
        <Box display="flex" justifyContent="center" px={6} py={3}>
            <HStack gap="6px" alignItems="center">
                {DOT_DELAY.map((delay, i) => (
                    <Box
                        key={i}
                        w="8px"
                        h="8px"
                        borderRadius="full"
                        bg={colors.textSecondary}
                        style={{
                            animation: 'bouncing 0.8s ease-in-out infinite',
                            animationDelay: delay,
                        }}
                    />
                ))}
            </HStack>
        </Box>
    );
};

export default TypingIndicator;
